import FullFieldsMap from "./map.categories[name].fields";

export const SearchFieldsUiSpec = {
  rent_period_: {
    ...FullFieldsMap.rent_period,
    type: "radio",
    operation: "eq",
  },
  family: {
    ...FullFieldsMap.family,
    type: "radio",
    operation: "eq",
  },
  type: {
    ...FullFieldsMap.type,
    operation: "eq",
    options: FullFieldsMap.type.options.slice(0, 3),
    type: "radio",
  },
  beds: {
    ...FullFieldsMap.beds,
    type: "radio",
    operation: "eq",
    label: { ar: "الغرف" },
  },
  livings: {
    ...FullFieldsMap.livings,
    type: "radio",
    operation: "eq",
  },
  wc: {
    ...FullFieldsMap.wc,
    type: "radio",
    operation: "eq",
  },
  furnished: {
    ...FullFieldsMap.furnished,

    operation: "eq",
    type: "checkbox",
  },
  car_entrance: {
    ...FullFieldsMap.car_entrance,

    operation: "eq",
    type: "checkbox",
  },
  ac: {
    ...FullFieldsMap.ac,

    operation: "eq",
    type: "checkbox",
  },
  special_entrance: {
    ...FullFieldsMap.special_entrance,

    operation: "eq",
    type: "checkbox",
    span: 1,
  },
  two_entrances: {
    ...FullFieldsMap.two_entrances,

    operation: "eq",
    type: "checkbox",
    span: 1,
  },
  private_roof: {
    ...FullFieldsMap.private_roof,

    operation: "eq",
    type: "checkbox",
    span: 1,
  },
  apartment_in_villa: {
    ...FullFieldsMap.apartment_in_villa,
    operation: "eq",
    type: "checkbox",
    span: 1,
  },
  price: {
    ...FullFieldsMap.price,
    type: "multiInput",
    span: 2,
    controls: [
      {
        operation: "gte",
        placeholder: { ar: "السعر الأدنى" },
        min: 100,
        max: 100000000,
        type: "number",
      },
      {
        operation: "lte",
        placeholder: { ar: "السعر الأعلى" },
        min: 100,
        max: 100000000,
        type: "number",
      },
    ],
  },
  prices: {
    type: "prices",
    name: "prices",
    label: { ar: "الدفع " },
    span: 2,
    options: [
      {
        label: {
          ar: "دفعة",
        },
        value: "price",
      },
      {
        label: {
          ar: "دفعتين",
        },
        value: "price_2_payments",
      },
      {
        label: {
          ar: "4 دفعات",
        },
        value: "price_4_payments",
      },
      {
        label: {
          ar: "شهري",
        },
        value: "price_12_payments",
      },
    ],
    controls: [
      {
        operation: "gte",
        placeholder: { ar: "السعر الأدنى" },
        min: 1,
        max: 100000000,
        type: "number",
        positive: true,
        format: "currency",
      },
      {
        operation: "lte",
        placeholder: { ar: "السعر الأعلى" },
        min: 100,
        positive: true,
        format: "currency",

        max: 100000000,
        type: "number",
      },
    ],
  },
  fl: {
    ...FullFieldsMap.fl,
    operation: "eq",
    type: "select",
    max: 22,
    min: 1,
  },
  age: {
    ...FullFieldsMap.age,
    operation: "eq",
    type: "select",
    options: [
      {
        label: {
          ar: "الكل",
          en: "Unset",
        },
      },
    ].concat(...FullFieldsMap.age.options.slice(2)),
    span: 2,
  },

  meter_price: {
    ...FullFieldsMap.meter_price,
    operation: "lte",
    type: "text",
    span: 2,
  },
  area: {
    ...FullFieldsMap.area,
    type: "multiInput",
    span: 2,
    controls: [
      {
        operation: "gte",
        placeholder: { ar: "أقل مساحة" },
        min: 100,
        max: 100000000,
        type: "number",
      },
      {
        operation: "lte",
        placeholder: { ar: "أعلى مساحة" },
        min: 100,
        max: 100000000,
        type: "number",
      },
    ],
  },
  street_direction: {
    ...FullFieldsMap.street_direction,
    operation: "eq",
    type: "select",
  },
  street_width: {
    ...FullFieldsMap.street_width,
    operation: "gte",
    min: 5,
    step: 5,
    max: 50,
    type: "slider",
  },
  stairs: {
    ...FullFieldsMap.stairs,
    operation: "lte",
    type: "checkbox",
  },
  apts: {
    ...FullFieldsMap.apts,
    operation: "eq",
    type: "select",
  },
  driver: {
    ...FullFieldsMap.driver,
    operation: "eq",
    type: "checkbox",
  },
  maid: {
    ...FullFieldsMap.maid,
    operation: "eq",
    type: "checkbox",
  },
  pool: {
    ...FullFieldsMap.pool,
    operation: "eq",
    type: "checkbox",
  },
  ketchen: {
    ...FullFieldsMap.ketchen,
    operation: "eq",
    type: "checkbox",
  },
  basement: {
    ...FullFieldsMap.basement,
    operation: "eq",
    type: "checkbox",
  },
  duplex: {
    ...FullFieldsMap.duplex,
    operation: "eq",
    type: "checkbox",
  },
  stores: {
    ...FullFieldsMap.stores,
    operation: "eq",
    type: "radio",
  },
  tent: {
    ...FullFieldsMap.tent,
    operation: "eq",
    type: "checkbox",
  },
  family_section: {
    ...FullFieldsMap.family_section,
    operation: "eq",
    type: "checkbox",
  },
  fb: {
    ...FullFieldsMap.fb,
    operation: "eq",
    type: "checkbox",
  },
  vb: {
    ...FullFieldsMap.vb,
    operation: "eq",
    type: "checkbox",
  },
  playground: {
    ...FullFieldsMap.playground,
    operation: "eq",
    type: "checkbox",
  },
  extra_unit: {
    ...FullFieldsMap.extra_unit,
    operation: "eq",
    type: "checkbox",
  },
  villa_type: {
    ...FullFieldsMap.villa_type,
    type: "radio",
    operation: "eq",
  },
  near_bus: {
    ...FullFieldsMap.near_bus,
    type: "checkbox",
    operation: "eq",
    citySpecific: true,
    cityId: 21, // Riyadh
  },
  near_metro: {
    ...FullFieldsMap.near_metro,
    type: "checkbox",
    operation: "eq",
    citySpecific: true,
    cityId: 21, // Riyadh
  }
};
export default SearchFieldsUiSpec;
